import Tooltip from "@material-ui/core/Tooltip";
import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import "../../../Assets/Css/index.css";
import mailIcon from "../../../Assets/Icons/Mail/mail-16px.svg";

class Email extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      copyText: "",
      copied: false,
      animation: false,
    };

    this.copyText = this.copyText.bind(this);
  }

  copyText() {
    const { data } = this.props;
    this.setState({
      copyText: data.emailid,
      copied: true,
      animation: !this.state.animation,
    });
  }

  render() {
    const { data } = this.props;
    return (
      <CopyToClipboard text={data.emailid}>
        <span
          className="dir-emp-links mobil-svg-hover emp-mail"
          onClick={this.copyText}
        >
          <Tooltip
            PopperProps={{
              disablePortal: true,
            }}
            title={data.emailid}
            placement="top"
            size="16px"
          >
            <span className="emp-mail-icon">
              <img src={mailIcon}></img>
            </span>
          </Tooltip>
          <span className="emp-mail-text t-14">{data.emailid}</span>
          <p
            className={this.state.animation ? "emailAnimation" : "display-none"}
          >
            Copied
          </p>
        </span>
      </CopyToClipboard>
    );
  }
}
export default Email;
